/**
 * Mixes two different hexadecimal colors (eg. #ffffff), similar to `mix` in SASS.
 * @param {string} color_1 First color to be mixed
 * @param {string} color_2 Second color to be mixed
 * @param {number} [weight] How much weight the first color has on the second color
 * @return {string} The result of mixing the two colors
 */
function mixColors(color_1, color_2, weight = 50) {
    const rawColor1 = color_1.substr(1);
    const rawColor2 = color_2.substr(1);

    const result = ['#'];
    for (let i = 0; i <= 5; i += 2) {
        // loop through each of the 3 hex pairs—red, green, and blue
        let v1 = hexToDec(rawColor1.substr(i, 2));
        let v2 = hexToDec(rawColor2.substr(i, 2));

        // combine the current pairs from each source color, according to the specified weight
        let val = decToHex(Math.floor(v2 + (v1 - v2) * (weight / 100.0)));

        while (val.length < 2) {
            val = '0' + val;
        }

        result.push(val);
    }

    return result.join('');
}

function decToHex(dec) {
    return dec.toString(16);
}

function hexToDec(hex) {
    return parseInt(hex, 16);
}

export default mixColors;
